(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .filter('filesize', fileSizeFactory);

    var units = ['B', 'KB', 'MB', 'GB', 'TB']

    function fileSizeFactory() {
        return function fileSize(size) {
            if (isNaN(size = parseInt(size)))
                return null;
            var i = Math.floor(Math.log(size || 1) / Math.log(1024));
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + units[i];
        };
    }
})();